<div class="page-container account-linking-detail-container container pt-2">
  <h1 class="header col-12 mb-1"> Manage Linked Account </h1>

  @if (!loading) {
    <div class="actions-container mb-3">
      <button
        type="button"
        mat-button
        color="primary"
        (click)="nav('account-linking')"
      >
        <mat-icon>arrow_back_ios</mat-icon> Back to Account Linking
      </button>
    </div>

    <div class="row mb-4">
      <div class="col-6">
        <div class="info-card">
          <div class="card-header">
            <span class="card-title-container">
              Direct Account:
              <span class="card-title mb-0 ms-2">
                {{ linkedAccountInfo.DirectAccount.DirAccountIDDisplay }}
              </span>
            </span>

            <span class="card-title-container">
              Link Status:
              <span
                [class]="
                  'card-title mb-0 ms-2 ' +
                  linkStatusKey[linkedAccountInfo.LinkedAccount.Status]?.color
                "
              >
                {{
                  linkStatusKey[linkedAccountInfo.LinkedAccount.Status]?.label
                }}
              </span>
            </span>
          </div>

          <div class="account-details-card">
            <div class="custom-tabs">
              <mat-tab-group [selectedIndex]="directAccountTab">
                <mat-tab label="Account Information">
                  <div class="row">
                    @for (
                      infoPoint of directAccountInfoKey;
                      track infoPoint.label
                    ) {
                      @if (
                        infoPoint.nestedVarset &&
                        linkedAccountInfo['DirectAccountDetails'][
                          infoPoint.nestedVarset
                        ][infoPoint.varSet][infoPoint.varName]
                      ) {
                        <app-card-infopoint
                          class="col-sm-4 col-6"
                          [datapoint]="infoPoint"
                          [dataset]="
                            linkedAccountInfo['DirectAccountDetails'][
                              infoPoint.nestedVarset
                            ]
                          "
                        />
                      } @else {
                        @if (
                          linkedAccountInfo[infoPoint.varSet][infoPoint.varName]
                        ) {
                          <app-card-infopoint
                            class="col-sm-4 col-6"
                            [datapoint]="infoPoint"
                            [dataset]="linkedAccountInfo"
                          />
                        }
                      }
                    }
                  </div>
                </mat-tab>

                <mat-tab label="Account Holder Info.">
                  <app-expanding-table
                    [dataset]="linkedAccountInfo?.DirectAccountEntities"
                    [evalKey]="directAccountHolderKey"
                  />
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="info-card">
          <div class="card-header">
            Shell Account Details

            @if (linkedAccountInfo?.LinkedAccount?.Status !== 'U') {
              <span class="card-title-container">
                Match Score:
                <span class="card-title mb-0 ms-2">
                  {{
                    findMatchScore(linkedAccountInfo.TradeAccount?.AccountID)
                  }}
                </span>
              </span>
            }

            <span>
              @if (linkedAccountInfo?.LinkedAccount?.Status === 'S') {
                <button
                  type="button"
                  matButton
                  color="warn"
                  (click)="clearShellAccount()"
                >
                  <mat-icon>close</mat-icon>Clear
                </button>
              }

              @switch (linkedAccountInfo?.LinkedAccount?.Status) {
                @case ('L') {
                  <button
                    type="button"
                    matButton="elevated"
                    (click)="linkAccount('U')"
                  >
                    <mat-icon>link_off</mat-icon>Unlink
                  </button>
                }
                @case ('S')
                @case ('P') {
                  <button
                    type="button"
                    matButton="elevated"
                    color="accent"
                    (click)="linkAccount('L')"
                  >
                    <mat-icon>link</mat-icon>Link
                  </button>
                }
                @case ('U') {
                  <button
                    type="button"
                    matButton="elevated"
                    color="warn"
                    (click)="linkAccount('I')"
                  >
                    <mat-icon>signal_wifi_bad</mat-icon>Ignore Link
                  </button>
                }
                @case ('I') {
                  <button
                    type="button"
                    matButton="elevated"
                    color="accent"
                    (click)="linkAccount('U')"
                  >
                    <mat-icon>wifi_find</mat-icon>Unignore Link
                  </button>
                }
              }
            </span>
          </div>

          <div class="account-details-card">
            <div class="custom-tabs">
              @if (
                ['L', 'P', 'S'].includes(
                  linkedAccountInfo.LinkedAccount?.Status
                )
              ) {
                <mat-tab-group [selectedIndex]="linkedAccountTab">
                  <mat-tab label="Account Information">
                    <div class="row">
                      @for (
                        infoPoint of shellAccountInfoKey;
                        track infoPoint.label
                      ) {
                        @if (
                          linkedAccountInfo[infoPoint.varSet][infoPoint.varName]
                        ) {
                          <app-card-infopoint
                            class="col-sm-4 col-6"
                            [datapoint]="infoPoint"
                            [dataset]="linkedAccountInfo"
                          />
                        }
                      }
                    </div>
                  </mat-tab>

                  <mat-tab label="Account Holder Info.">
                    <app-expanding-table
                      [dataset]="linkedAccountInfo?.TradeEntities"
                      [evalKey]="shellAccountHolderKey"
                    />
                  </mat-tab>
                </mat-tab-group>
              } @else if (
                ['U', 'I'].includes(linkedAccountInfo.LinkedAccount?.Status)
              ) {
                <div class="card-info row no-details">
                  <div class="col-12">
                    @if (linkedAccountInfo.LinkedAccount?.Status === 'U') {
                      No available details. Search/Select an account below for
                      comparison
                    } @else if (
                      linkedAccountInfo.LinkedAccount?.Status === 'I'
                    ) {
                      Link ignored. Unignore to review and link shell account.
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (['U', 'P', 'S'].includes(linkedAccountInfo.LinkedAccount?.Status)) {
      <div class="row mb-4">
        <div class="col-12">
          <div class="info-card">
            <div class="card-header"> Potential Shell Account Matches </div>

            <div class="card-info row">
              <div class="col-12">
                <app-search-account-grid
                  [defaultSearchIds]="defaultSearchIds"
                  (setShellAccount)="setShellAccount($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (linkedAccountInfo.LinkedAccountHistory) {
      <div class="row mb-4">
        <div class="col-12">
          <div class="info-card">
            <div class="card-header"> Account Linking History </div>

            <div class="card-info row">
              <div class="col-12">
                <app-expanding-table
                  [dataset]="linkedAccountInfo.LinkedAccountHistory"
                  [evalKey]="linkHistoryKey"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }

  <ngx-loading [show]="loading" />
</div>
